import ForgotPassword from './ForgotPassword.react'

export default ForgotPassword